import React from "react";

export default function CameraPanel({ camera, setCameras, closePanel, onDelete, onDuplicate }) {
  if (!camera) return null;

  // Update a field on the camera
  const handleChange = (field, value) => {
    setCameras(prev =>
      prev.map(cam => cam.id === camera.id ? { ...cam, [field]: value } : cam)
    );
  };

  // Responsive: right-side drawer on desktop, bottom-sheet on mobile
  const isMobile = typeof window !== "undefined" && window.innerWidth < 640;

  return (
    <div
      className="fixed z-50 bg-gray-900 text-white transition-all duration-300 shadow-2xl"
      style={{
        right: isMobile ? "unset" : 0,
        top: isMobile ? "unset" : 0,
        left: isMobile ? 0 : "unset",
        bottom: isMobile ? 0 : "unset",
        width: isMobile ? "100vw" : 360,
        maxWidth: isMobile ? "100vw" : 360,
        height: isMobile ? "60vh" : "100vh",
        maxHeight: "100vh",
        borderLeft: isMobile ? "none" : "1.5px solid #282828",
        borderTopLeftRadius: isMobile ? 20 : 0,
        borderTopRightRadius: isMobile ? 20 : 0,
        boxShadow: isMobile ? "0 -2px 32px #000b" : "0 0 24px #000b"
      }}
    >
      <button
        onClick={closePanel}
        className="absolute top-3 right-3 text-xl text-gray-400 hover:text-gray-200"
        aria-label="Close"
      >✕</button>
      <div className="p-6 pt-10">
        <h2 className="text-2xl font-bold mb-4" style={{ color: camera.color }}>{camera.name}</h2>
        <div className="mb-4">
          <label className="block text-sm mb-1">Name</label>
          <input
            className="bg-gray-700 text-white px-3 py-2 rounded w-full outline-none focus:ring-2 focus:ring-sky-500"
            value={camera.name}
            onChange={e => handleChange('name', e.target.value)}
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm mb-1">Rotationº</label>
          <input
            type="range"
            min={-180}
            max={180}
            value={camera.angle}
            onChange={e => handleChange('angle', Number(e.target.value))}
            className="w-full accent-sky-500"
          />
          <input
            type="number"
            className="bg-gray-700 text-white px-2 py-1 rounded-lg w-20 text-center mt-1"
            value={Math.round(camera.angle)}
            onChange={e => handleChange('angle', Number(e.target.value))}
            min={-180}
            max={180}
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm mb-1">FOVº</label>
          <input
            type="range"
            min={10}
            max={220}
            value={camera.fov}
            onChange={e => handleChange('fov', Number(e.target.value))}
            className="w-full accent-sky-500"
          />
          <input
            type="number"
            className="bg-gray-700 text-white px-2 py-1 rounded-lg w-20 text-center mt-1"
            value={camera.fov}
            min={10}
            max={999}
            onChange={e => handleChange('fov', Number(e.target.value))}
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm mb-1">Reach (ft)</label>
          <input
            type="range"
            min={164}
            max={6562}
            value={camera.reach}
            onChange={e => handleChange('reach', Number(e.target.value))}
            className="w-full accent-sky-500"
          />
          <input
            type="number"
            className="bg-gray-700 text-white px-2 py-1 rounded-lg w-24 text-center mt-1"
            value={camera.reach}
            min={1}
            max={99999}
            onChange={e => handleChange('reach', Number(e.target.value))}
          />
        </div>
        <div className="mb-6">
          <label className="block text-sm mb-1">Color</label>
          <input
            type="color"
            value={camera.color}
            onChange={e => handleChange('color', e.target.value)}
            className="rounded-lg border-none p-0 w-10 h-10 bg-transparent cursor-pointer"
          />
        </div>
        <div className="flex flex-row gap-3">
          <button
            className="bg-red-500 hover:bg-red-600 text-white rounded-lg px-4 py-2 font-semibold shadow"
            onClick={() => { onDelete(camera.id); closePanel(); }}
          >Delete</button>
          <button
            className="bg-sky-500 hover:bg-sky-600 text-white rounded-lg px-4 py-2 font-semibold shadow"
            onClick={() => { onDuplicate(camera); closePanel(); }}
          >Duplicate</button>
        </div>
      </div>
    </div>
  );
}
